import { Theme, css } from '@emotion/react';

export const dialogActionsStyles = ({ spacing }: Theme) => css`
  padding: ${spacing(3)}px;
`;
